import React, { useState, useEffect } from 'react';
import { 
  Phone,  ArrowRight, Check, 
  ChevronLeft, ChevronRight, Sprout, 
  Trees, Scissors, Home as HomeIcon, Grid, Fence, Plus, Minus, Mail,
  Zap
} from 'lucide-react';
import ProjectsSection from '../Component/ProjectsSection';
import { Link } from 'react-router-dom';





// ================= HERO SLIDER =================
const HeroSlider = () => {


  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
   const slides = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=2400&auto=format&fit=crop",
      badge: "Garten- & Landschaftsbau",
      title: "Außenräume,\nperfekt umgesetzt",
      subtitle: "Palloshigalabau gestaltet hochwertige Gärten und Außenanlagen in Deutschland   individuell, langlebig und stilvoll.",
    },
    {
      id: 2,
  image: "/img/balcony.jpg", // <-- correct path
      badge: "Handwerk & Qualität",
      title: "Holz, Stein & Natur\nin Harmonie",
      subtitle: "Von Holzterrassen über Pflasterarbeiten bis hin zu Zaunbau – wir realisieren Außenbereiche mit Anspruch.",
    }
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setTimeout(() => setIsAnimating(false), 1000);
  };

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    setTimeout(() => setIsAnimating(false), 1000);
  };

  return (
    
    <header className="relative w-full h-[750px] lg:h-[900px] overflow-hidden group font-sans">
      {slides.map((slide, index) => (
        <div key={slide.id} className={`absolute inset-0 w-full h-full transition-all duration-1000 ease-in-out ${index === currentSlide ? "opacity-100 visible" : "opacity-0 invisible"}`}>
          <div className="w-full h-full overflow-hidden">
             <img src={slide.image} alt="Gartenbau" className={`w-full h-full object-cover transform transition-transform duration-[20000ms] ease-linear ${index === currentSlide ? "scale-110" : "scale-100"}`} />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/40 to-transparent z-10"></div>
          <div className="absolute inset-0 flex items-center z-20">
            <div className="max-w-[1600px] mx-auto px-6 sm:px-8 lg:px-12 w-full">
              <div className="max-w-4xl space-y-8">
                <div key={currentSlide} className="space-y-6">
                  <div className="opacity-0 animate-slide-up" style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}>
                     <span className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/30 backdrop-blur-md px-5 py-2 rounded-full text-emerald-300 text-sm font-bold uppercase tracking-widest shadow-lg">
                        <Zap size={14} className="text-emerald-400" /> {slide.badge}
                     </span>
                  </div>
                  <h1 className="text-5xl md:text-7xl lg:text-8xl font-black leading-[1.1] text-white opacity-0 animate-slide-up drop-shadow-2xl" style={{ animationDelay: '300ms', animationFillMode: 'forwards' }}>
                    {slide.title.split('\n')[0]} <br />
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-200">{slide.title.split('\n')[1]}</span>
                  </h1>
                  <p className="text-lg md:text-2xl text-slate-200 leading-relaxed max-w-2xl opacity-0 animate-slide-up" style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}>
                    {slide.subtitle}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-5 pt-4 opacity-0 animate-slide-up" style={{ animationDelay: '700ms', animationFillMode: 'forwards' }}>
                  
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {/* Controls */}
      <div className="absolute bottom-12 left-12 z-30 flex items-center gap-6">
        <div className="flex gap-2">
            {slides.map((_, idx) => (
                <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-1.5 rounded-full transition-all duration-500 ${idx === currentSlide ? "bg-emerald-400 w-12" : "bg-white/30 w-6"}`} />
            ))}
        </div>
        <div className="flex gap-3">
          <button onClick={prevSlide} className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-slate-900 transition-all"><ChevronLeft size={24}/></button>
          <button onClick={nextSlide} className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-slate-900 transition-all"><ChevronRight size={24}/></button>
        </div>
      </div>
      <style>{`
        @keyframes slide-up { 0% { opacity: 0; transform: translateY(40px); } 100% { opacity: 1; transform: translateY(0); } }
        .animate-slide-up { animation: slide-up 1s cubic-bezier(0.19, 1, 0.22, 1); }
      `}</style>
    </header>
  );
};

// ================= MAIN HOME PAGE =================
const Home = () => {
  const [openFaq, setOpenFaq] = useState(null);


  const coreServices = [
   { icon: <Trees />, title: "Baumfällen", desc: "Professionelle und sichere Baumfällung inklusive Entsorgung." },
{ icon: <Sprout />, title: "Gartenpflege", desc: "Ganzjährige Pflegekonzepte für private und gewerbliche Anlagen." },
{ icon: <Scissors />, title: "Heckenschnitt", desc: "Fachgerechter Rück- und Formschnitt für gesunde Pflanzen." },
{ icon: <HomeIcon />, title: "Holzterrassen", desc: "Individuelle Terrassen aus Holz oder WPC – langlebig & modern." },
{ icon: <Grid />, title: "Pflasterarbeiten", desc: "Wege, Einfahrten und Terrassen präzise gepflastert." },
{ icon: <Fence />, title: "Zaunbau", desc: "Sichtschutz- und Zaunsysteme aus Metall, Holz oder Gabionen." }

  ];

  const processSteps = [
  { num: "01", title: "Beratung vor Ort", text: "Wir analysieren Ihre Wünsche und die Gegebenheiten direkt bei Ihnen." },
{ num: "02", title: "Planung & Angebot", text: "Sie erhalten ein klares Konzept mit transparentem Festpreis." },
{ num: "03", title: "Fachgerechte Umsetzung", text: "Unser Team realisiert Ihr Projekt termintreu und sauber." }

  ];



  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <HeroSlider />

      {/* ================= 1. LEISTUNGEN ================= */}
      <section className="py-32 bg-slate-50 relative overflow-hidden">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-20 gap-8">
            <div className="max-w-2xl">
              <h2 className="text-emerald-700 font-bold uppercase tracking-widest text-sm mb-4">Unsere Leistungen</h2>
              <h3 className="text-4xl md:text-6xl font-black text-slate-900">Alles für Ihr grünes <span className="text-emerald-600">Paradies.</span></h3>
            </div>
            <p className="text-slate-500 text-xl max-w-md">Wir bieten Ihnen das komplette Spektrum moderner Garten- und Landschaftspflege aus einer Hand.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {coreServices.map((service, idx) => (
              <div key={idx} className="bg-white p-10 rounded-[2.5rem] shadow-sm hover:shadow-2xl transition-all duration-500 border border-slate-100 group">
                <div className="w-20 h-20 mb-8 flex items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-all transform group-hover:scale-110">
                  {service.icon}
                </div>
                <h4 className="text-2xl font-bold mb-4">{service.title}</h4>
                <p className="text-slate-500 leading-relaxed text-lg mb-8">{service.desc}</p>
               
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 2. DER PROZESS (NEW & COOL) ================= */}
<section className="py-24 bg-slate-50">
  <div className="max-w-[1600px] mx-auto px-6 lg:px-8">
    
    {/* Header */}
    <div className="text-center mb-20">
      <span className="inline-block py-1 px-3 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider mb-4">
        Der Ablauf
      </span>
      <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
        Traumgarten in <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-500">3 Schritten</span>
      </h2>
    </div>

    {/* Grid */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {processSteps.map((step, i) => (
        <div key={i} className="relative bg-white p-8 rounded-3xl shadow-sm border border-slate-100 overflow-hidden group hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
          
          {/* Giant Watermark Number */}
          <div className="absolute -right-4 -top-4 text-9xl font-black text-slate-50 group-hover:text-emerald-50 transition-colors duration-300 select-none">
            {step.num}
          </div>

          <div className="relative z-10">
            {/* Small decorative line */}
            <div className="w-12 h-1.5 bg-emerald-500 rounded-full mb-6 group-hover:w-20 transition-all duration-300"></div>
            
            <h4 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-emerald-700 transition-colors">
              {step.title}
            </h4>
            <p className="text-slate-500 leading-relaxed">
              {step.text}
            </p>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>

      {/* ================= 3. ÜBER UNS DETAIL ================= */}
      <section className="py-32 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-emerald-600/10 blur-[150px] -z-0"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center relative z-10">
          <div className="relative">
            <img src="/img/garden1.jpg" alt="Gartenprofi" className="rounded-[3rem]  object-contain shadow-2xl grayscale hover:grayscale-0 transition-all duration-1000 h-[600px] w-full object-cover" />
            <div className="absolute -bottom-10 -right-10 bg-emerald-600 p-12 rounded-[2.5rem] hidden xl:block shadow-2xl">
                <div className="text-5xl font-black mb-2">15+</div>
                <div className="text-emerald-100 font-bold uppercase tracking-widest text-sm">Jahre Erfahrung</div>
            </div>
          </div>
          <div className="space-y-10">
            <div>
                <h2 className="text-emerald-400 font-bold uppercase tracking-widest text-sm mb-4">Warum Wir?</h2>
                <h3 className="text-4xl md:text-6xl font-black mb-8 leading-tight">Qualität, Erfahrung <br/>und Verlässlichkeit.</h3>
                <p className="text-slate-400 text-xl leading-relaxed">Palloshigalabau ist Ihr Fachbetrieb für Garten- und Landschaftsbau
in Deutschland . Wir stehen für saubere Arbeit,
klare Kommunikation und nachhaltige Ergebnisse.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6"> 
                {[ "Festpreisgarantie", "Termintreue", "Profi-Maschinenpark"].map((item, i) => (
                    <div key={i} className="flex items-center gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 hover:bg-white/10 transition-all">
                        <Check className="text-emerald-400" size={24} strokeWidth={3} />
                        <span className="font-bold text-lg">{item}</span>
                    </div>
                ))}
                            <Link to="/about" className="bg-white text-slate-900 px-10 py-5 rounded-2xl font-black text-xl hover:bg-emerald-500 hover:text-white text-center transition-all md:text-left">UNSERE STORY</Link>

            </div>
          </div>
        </div>
      </section>

      {/* ================= 4. PROJEKTE (NEW) ================= */}
<ProjectsSection/>



      {/* ================= 5. FAQ ================= */}
      <section className="py-32 bg-slate-50">
        <div className="max-w-[1600px] mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-emerald-700 font-bold uppercase tracking-widest text-sm mb-4">Fragen & Antworten</h2>
            <h3 className="text-4xl font-black">Was Sie wissen müssen.</h3>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
                <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-10 py-8 text-left flex justify-between items-center hover:bg-slate-50 transition-all">
                  <span className="font-bold text-xl text-slate-800">{faq.q}</span>
                  {openFaq === idx ? <Minus className="text-emerald-600" /> : <Plus className="text-slate-400" />}
                </button>
                <div className={`px-10 transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-60 pb-10 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                  <p className="text-slate-500 text-lg leading-relaxed">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-[1500px] mx-auto bg-slate-900 rounded-[3rem] p-12 lg:p-24 text-center relative overflow-hidden shadow-2xl shadow-slate-900/50">
            <div className="absolute top-0 left-0 w-full h-full bg-emerald-600/5 pointer-events-none"></div>
            <div className="relative z-10 max-w-4xl mx-auto space-y-12">
                <h2 className="text-4xl md:text-7xl font-black text-white leading-tight">Bereit für Ihren <br/>
<span className="text-emerald-500">perfekten Außenbereich?</span></h2>
<p>
Palloshigalabau – Ihr Partner für hochwertige Garten- und Landschaftsbau-Projekte
in Deutschland
</p>                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                    <button className="bg-emerald-600 hover:bg-emerald-500 text-white px-12 py-6 rounded-2xl font-black text-2xl transition-all shadow-2xl shadow-emerald-900/40 flex items-center justify-center gap-3">
                        <Mail size={32} /> JETZT ANFRAGEN
                    </button>
                    <a href="tel:+4915735547097" className="bg-white/10 hover:bg-white/20 text-white px-12 py-6 rounded-2xl font-black text-2xl transition-all flex items-center justify-center gap-3 backdrop-blur-md border border-white/20">
                        <Phone size={32} /> ANRUFEN
                    </a>
                </div>
            </div>
        </div>
      </section>
    </div>
  );
};

const faqs = [
  { 
 q: "Arbeiten Sie auch in der Deutschland?", 
 a: "Ja, Palloshigalabau ist sowohl in Deutschland als auch  tätig." 
},
{ 
 q: "Bieten Sie Komplettlösungen an?", 
 a: "Ja, von der Planung bis zur fertigen Umsetzung erhalten Sie alles aus einer Hand." 
},
{ 
 q: "Gibt es Wartungs- und Pflegeverträge?", 
 a: "Selbstverständlich – wir bieten flexible Pflegepakete für jede Gartengröße." 
},
{ 
 q: "Erstellen Sie kostenlose Angebote?", 
 a: "Ja, nach einer Besichtigung erstellen wir Ihnen ein unverbindliches Festpreisangebot." 
}
  ];

export default Home;